import { getColorName, isHexColor } from '../utils';
import { ADMINISTRATION_DATA_TYPE } from '../../components/pages/administration/AdministrationItemsFormFields';

function handleInventoryTable(values) {
  if (values?.ButtonColorHex) {
    values.ButtonColor = isHexColor(values.ButtonColorHex)
      ? getColorName(values.ButtonColorHex.toUpperCase())
      : values.ButtonColorHex;
    values.ButtonColorName = values.ButtonColor;
  }
  
  if (values?.SortingWeight) {
    values.SalesMenuSorter = values.SortingWeight;
  }
  if (values?.SpecialFunctionTypeId) {
    values.SpecialFunctionType = values.SpecialFunctionTypeId;
  }
}

function handleCategoryTable(values) {
  if (values.ButtonColorHex) {
    values.ButtonColor = isHexColor(values.ButtonColorHex)
      ? getColorName(values.ButtonColorHex.toUpperCase())
      : values.ButtonColorHex;
    values.ButtonColorName = values.ButtonColor;
  }
}

function handleDictionaryWordTable(values) {
  if (values?.SortingWeight) {
    values.DictionaryWordSorter = values?.SortingWeight;
  }
}

export const tableTypeHandlerMapping = {
  [ADMINISTRATION_DATA_TYPE.INVENTORY_TABLE]: handleInventoryTable,
  [ADMINISTRATION_DATA_TYPE.CATEGORY_TABLE]: handleCategoryTable,
  [ADMINISTRATION_DATA_TYPE.DICTIONARY_WORD_TABLE]: handleDictionaryWordTable,
};